import { markInternalNavigation } from "./attributionCapture";


/**
 * Common navigation utility for property detail pages
 */
export const updatePreviewURL = (url, category) => {
  if (category === "REO" && !(url.includes('/preview'))) {
    window.history.replaceState(null, '', window.location.pathname.replace('/bank-owned-home', '/bank-owned-home/preview'));
  } else if (category === "SHRT_SALE" && !(url.includes('/preview'))) {
    window.history.replaceState(null, '', window.location.pathname.replace('/short-sale-home', '/short-sale-home/preview'));
  } else if (category === "NON_REO" && !(url.includes('/preview'))) {
    window.history.replaceState(null, '', window.location.pathname.replace('/non-bank-owned-home', '/non-bank-owned-home/preview'));
  } else if (category === "FORECLOSURE" && !(url.includes('/preview'))) {
    window.history.replaceState(null, '', window.location.pathname.replace('/foreclosure-home', '/foreclosure-home/preview'));
  } else if (category === "SC" && !(url.includes('/preview'))) {
    window.history.replaceState(null, '', window.location.pathname.replace('/second-chance-home', '/second-chance-home/preview'));
  } else if (category === "ABS" && !(url.includes('/preview'))) {
    window.history.replaceState(null, '', window.location.pathname.replace('/absolute-auction-home', '/absolute-auction-home/preview'));
  } else if (category === "NPL" && !(url.includes('/preview'))) {
    window.history.replaceState(null, '', window.location.pathname.replace('/non-performing-loan', '/non-performing-loan/preview'));
  } else if (category === "COMMERCIAL" && !(url.includes('/preview'))) {
    window.history.replaceState(null, '', window.location.pathname.replace('/commercial-building', '/commercial-building/preview'));
  }
};

/**
 * Common navigation utility for property detail pages
 * @param {string} propertyId - The property ID to navigate to
 * @param {string} listingUrl - Optional custom listing URL
 */
export const getPropertyURL = (url, category, status) => {
  // if (status === 'PACT' || status === 'PACT_NON_COMMERCIAL') {
  //   url = url.replace('property', 'property/preview');
  // }
  if (category === "REO") {
    url = url.replace('property', 'bank-owned-home');
  } else if (category === "SHRT_SALE") {
    url = url.replace('property', 'short-sale-home');
  } else if (category === "NON_REO") {
    url = url.replace('property', 'non-bank-owned-home');
  } else if (category === "FORECLOSURE") {
    url = url.replace('property', 'foreclosure-home');
  } else if (category === "SC") {
    url = url.replace('property', 'second-chance-home');
  } else if (category === "ABS") {
    url = url.replace('property', 'absolute-auction-home');
  } else if (category === "NPL") {
    url = url.replace('property', 'non-performing-loan');
  } else if (category === "COMMERCIAL") {
    url = url.replace('property', 'commercial-building');
  }
  return url;
};
export const navigateToProperty = (url, category, status) => {
  if (category && status) {
    url = getPropertyURL(url, category, status);
  } else if (category) {
    url = getPropertyURL(url, category);
  }
  markInternalNavigation();
  window.open(url);
};